module.exports = __webpack_public_path__ + "img/proList2_03.3a95ad47.jpg";